import { render, staticRenderFns } from "./CardsGrid.vue?vue&type=template&id=3ad8c456"
import script from "./CardsGrid.vue?vue&type=script&lang=js"
export * from "./CardsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports